import { baseApi } from "../baseApi";

const userApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getUserWithCode:builder.query({
            query:(code)=>`/user/get/${code}`
        }),
        createProfile:builder.mutation({
            query:(profile)=>({
                url:`/user/createprofile`,
                method:"POST",
                body:profile

            })
        }),
        uploadImage:builder.mutation({
            query: (body)=>({
                url:`/user/upload`,
                method: "POST",
                body
            })
        }),
        verifyProfile:builder.mutation({
            query:(code)=>({
                url:`/user/verifyprofile`,
                method:"POST",
                body:code

            }),
        }),
    })
})

export const {useGetUserWithCodeQuery, useCreateProfileMutation, useUploadImageMutation, useVerifyProfileMutation}= userApi